import React, { useContext, useEffect, useRef, useState } from 'react'
import { StyledTableContainer } from './styledElements'
import {
  Box,
  Button,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Pagination,
  Paper,
  Popover,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { getStatusChipStyles } from '../../libs/utils/table'
import CSTicketModal from './CSTicketModal'
import { AuthContext } from '../../libs/contexts/authContext'
import { useDispatch } from 'react-redux'
import { createHubspotTicket } from '../../store/actions/authActions'

const ApplicationManagementTableV3 = ({
  visibleRows = [],
  fetchNextRows,
  fetchingRows = false,
  products,
  stopLoading,
  total_pages,
}) => {
  const dispatch = useDispatch()
  // Component logic goes here
  const [fetchNext, setFetchNext] = useState(false)
  const [modalOpen, setModalOpen] = useState(
    [...visibleRows]?.reduce((acc, curr) => ({ ...acc, [curr.arcId]: false }), {})
  )
  const [anchorEl, setAnchorEl] = useState(null)
  const [openCSModal, setOpenCSModal] = useState(false)
  const [ticketARC, setTicketARC] = useState('')
  const [agentName, setAgentName] = useState('')
  const [currArcProdId, setCurrArcProdId] = useState('')

  const componentRef = useRef(null)

  const {
    agentObject: { firstName, lastName },
    affiliateCode,
    authObj,
  } = useContext(AuthContext)

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setFetchNext(entry.isIntersecting)
  //     },
  //     {
  //       threshold: 0.1, // Trigger when 10% of the component is visible
  //     }
  //   )

  //   if (componentRef.current) {
  //     observer.observe(componentRef.current)
  //   }

  //   return () => {
  //     if (componentRef.current) {
  //       observer.unobserve(componentRef.current)
  //     }
  //   }
  // }, [])

  useEffect(() => {
    console.log({ fetchingRows })
  }, [fetchingRows])

  useEffect(() => {
    setAgentName(`${firstName} ${lastName}`)
  }, [firstName, lastName])

  const handleActionsStart = (e, arcId) => {
    setAnchorEl(e.currentTarget)
    setModalOpen((prev) => ({ ...prev, [arcId]: !prev[arcId] }))
  }

  const handleContinueApp = (arcId) => {
    setAnchorEl(null)
    setModalOpen((prev) => ({ ...prev, [arcId]: false }))
  }

  const getProductUrl = (productId, distributorId) => {
    // const found = products?.find((p) => p.productId === productId)
    // if (!found) {
      const currentUrl = window.location.href
      if (currentUrl.includes('local') || currentUrl.includes('test')) {
        return `https://bbq-eapp-qa.afficiency.com/?productId=${productId}&distributorId=${distributorId}`
      } else if (currentUrl.includes('demo')) {
        return `https://bbq-eapp-demo.afficiency.com/?productId=${productId}&distributorId=${distributorId}`
      } else {
        return `https://bbq-eapp.afficiency.com/?productId=${productId}&distributorId=${distributorId}`
      }
    // }
    // return found.productUrl
  }

  const handleSupportSubmit = async (desc) => {
    const data = {
      arcID: ticketARC,
      agentName: agentName,
      agentEmail: authObj?.user?.email || null,
      description: desc,
      productId: currArcProdId,
      affiliateCode: affiliateCode,
    }
    dispatch(createHubspotTicket(data))
    setOpenCSModal(false)
  }

  const onPageChange = (value) => {
    if (visibleRows.length !== 0 && !fetchingRows) {
      fetchNextRows(value)
      // Trigger your desired function here
    }
  }

  return (
    <Paper mt={2}>
      <CSTicketModal
        open={openCSModal}
        setOpen={setOpenCSModal}
        defaultTicketARC={ticketARC}
        setTicketArc={setTicketARC}
        defaultAgentName={agentName}
        setAgentName={setAgentName}
        defaultAffiliateCode={affiliateCode}
        handleSupportSubmit={handleSupportSubmit}
      />
      <StyledTableContainer
        component={Paper}
        sx={{
          maxHeight: 450,
        }}
      >
        <Table
          stickyHeader
          sx={{
            minWidth: 700,
          }}
          aria-label="responsive table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Application ID Number</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>App Status</TableCell>
              <TableCell>Coverage</TableCell>
              <TableCell>Premium</TableCell>
              <TableCell>Policy #</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows?.length !== 0 &&
              !fetchingRows &&
              visibleRows.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    <Button variant="text" onClick={(e) => handleActionsStart(e, row.arcId)}>
                      {row.arcId}
                    </Button>

                    <Popover
                      open={modalOpen[row.arcId] || false}
                      anchorEl={anchorEl}
                      onClose={(e) => setModalOpen((prev) => ({ ...prev, [row.arcId]: false }))}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <List>
                        <ListItem
                          sx={{
                            py: 0,
                            px: 1,
                          }}
                        >
                          <ListItemButton
                            sx={{
                              pl: 1,
                              color: '#64768C',
                              borderRadius: 1,
                              '&:hover': {
                                bgcolor: '#DCE7F8',
                                color: '#3747B0',
                              },
                            }}
                            onClick={(e) => navigator.clipboard.writeText(row.arcId)}
                          >
                            <ListItemText primary="Copy ID Number" />
                          </ListItemButton>
                        </ListItem>
                        {(row.appStatus === 'In Progress' || row.appStatus === 'Not Started') &&
                          Date.parse(row.applicationDate) > Date.parse('Dec 8, 2023') && (
                            <ListItem sx={{ py: 0, px: 1 }}>
                              <ListItemButton
                                sx={{
                                  pl: 1,
                                  color: '#64768C',
                                  borderRadius: 1,
                                  '&:hover': {
                                    bgcolor: '#DCE7F8',
                                    color: '#3747B0',
                                  },
                                }}
                                target="_blank"
                                href={`${getProductUrl(row.productId, row.distributorId)}&arcId=${row.arcId}`}
                                onClick={(e) => handleContinueApp(row.arcId)}
                              >
                                <ListItemText primary="Continue Application" />
                              </ListItemButton>
                            </ListItem>
                          )}
                        {row.appPacketURL && (
                          <ListItem sx={{ py: 0, px: 1 }}>
                            <ListItemButton
                              sx={{
                                pl: 1,
                                color: '#64768C',
                                borderRadius: 1,
                                '&:hover': {
                                  bgcolor: '#DCE7F8',
                                  color: '#3747B0',
                                },
                              }}
                              onClick={(e) => {
                                window.open(row.appPacketURL, '_blank')
                              }}
                            >
                              <ListItemText primary="View Application Details" />
                            </ListItemButton>
                          </ListItem>
                        )}
                        {row.policyPacketURL && (
                          <ListItem sx={{ py: 0, px: 1 }}>
                            <ListItemButton
                              sx={{
                                pl: 1,
                                color: '#64768C',
                                borderRadius: 1,
                                '&:hover': {
                                  bgcolor: '#DCE7F8',
                                  color: '#3747B0',
                                },
                              }}
                              onClick={(e) => {
                                window.open(row.policyPacketURL, '_blank')
                              }}
                            >
                              <ListItemText primary="View Policy Packet" />
                            </ListItemButton>
                          </ListItem>
                        )}
                        {row.uwReportLink && (
                          <ListItem sx={{ py: 0, px: 1 }}>
                            <ListItemButton
                              onClick={(e) => {
                                window.open(row.uwReportLink, '_blank')
                              }}
                              sx={{
                                pl: 1,
                                color: '#64768C',
                                borderRadius: 1,
                                '&:hover': {
                                  bgcolor: '#DCE7F8',
                                  color: '#3747B0',
                                },
                              }}
                            >
                              <ListItemText primary="View UW Report" />
                            </ListItemButton>
                          </ListItem>
                        )}
                        <ListItem sx={{ py: 0, px: 1 }}>
                          <ListItemButton
                            onClick={(e) => {
                              setTicketARC(row.arcId)
                              setCurrArcProdId(row.productId)
                              setOpenCSModal(true)
                            }}
                            sx={{
                              pl: 1,
                              color: '#64768C',
                              borderRadius: 1,
                              '&:hover': {
                                bgcolor: '#DCE7F8',
                                color: '#3747B0',
                              },
                            }}
                          >
                            <ListItemText primary="Open a Customer Support Ticket" />
                          </ListItemButton>
                        </ListItem>
                      </List>
                    </Popover>
                  </TableCell>
                  <TableCell>{row.applicationDate}</TableCell>
                  <TableCell>{row.productName}</TableCell>
                  <TableCell>{row.ownerName}</TableCell>
                  <TableCell>
                    <Chip label={row.appStatus} sx={getStatusChipStyles(row.appStatus)} />
                  </TableCell>
                  <TableCell>{row.status === 'Declined' ? 'Not Eligible' : row.status}</TableCell>
                  <TableCell>{row.coverage && `$${row.coverage?.toLocaleString('en-us')}`}</TableCell>
                  <TableCell>{row.paymentPremium}</TableCell>
                  <TableCell>{row.policyNo}</TableCell>
                </TableRow>
              ))}
            {fetchingRows && (
              <TableRow>
                {Array.from({ length: 9 }, (_, i) => i).map((i) => {
                  return (
                    <TableCell key={i}>
                      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    </TableCell>
                  )
                })}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {visibleRows?.length !== 0 && !fetchingRows && (
        <Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
          <Stack spacing={2} py={2} px={2}>
            <Pagination
              onChange={(e, value) => onPageChange(value)}
              count={total_pages || 10}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </Box>
      )}
    </Paper>
  )
}

export default ApplicationManagementTableV3
